import { metricsDimensionTabs } from '@/metrics/constants'

export const returnSalesRatioMetrics = {
  [metricsDimensionTabs.product]: {
    total: { label: 'Unidades vendidas', summaryField: 'total_sales', seriesField: 'sales_count' },
    returned: { label: 'Unidades devueltas', summaryField: 'total_returns', seriesField: 'returns_count' },
    rate: {
      label: 'Tasa de devolución de productos',
      summaryField: 'total_returns_percentage',
      seriesField: 'returns_percentage',
    },
  },
  [metricsDimensionTabs.order]: {
    total: { label: 'Pedidos', summaryField: 'total_orders', seriesField: 'orders_count' },
    returned: { label: 'Solicitudes', summaryField: 'total_returned_orders', seriesField: 'returned_orders_count' },
    rate: {
      label: 'Tasa de devolución de pedidos',
      summaryField: 'total_returned_orders_percentage',
      seriesField: 'returned_orders_percentage',
    },
  },
}

export const returnSalesRatioDescriptions = {
  [metricsDimensionTabs.product]:
    'Dato global de la tienda: qué parte de las unidades vendidas ha vuelto como devolución, contado desde la fecha del pedido original.',
  [metricsDimensionTabs.order]:
    'Dato global de la tienda: qué parte de los pedidos ha tenido alguna solicitud de devolución o cambio, contado desde la fecha del pedido original.',
}
